import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { startLoading, stopLoading } from 'app/store/utilSlice';
import ClientTaskService from 'app/shared-components/client-tasks/services/ClientTaskService';

export const fetchMyTasks = createAsyncThunk(
  'myTasks/fetchMyTasks',
  async (userId, { dispatch }) => {
    dispatch(startLoading());
    try {
      const response = await ClientTaskService.getMyTasks(userId);
      return response;
    } finally {
      dispatch(stopLoading());
    }
  }
);

const myTasksSlice = createSlice({
  name: 'myTasks',
  initialState: {
    tasks: [],
    loading: false,
    error: null
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyTasks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyTasks.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks = action.payload;
      })
      .addCase(fetchMyTasks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const { clearError } = myTasksSlice.actions;
export default myTasksSlice.reducer;